const MAIN_ROOT_PATH = "/";

export const ROUTES = {
	main: {
		path: MAIN_ROOT_PATH,
		createURL: () => ROUTES.main.path,
	},
} as const;
